// Category controls inherit the actual price size of the product surface they accompany.
const syncCategoryLinks = () => {
  for (const link of document.querySelectorAll('main a[href*="/collections/"]')) {
    if (!link.classList.contains('category-shop-link') && !/^(view all|shop all|shop the complete collection)\b/i.test(link.textContent.trim())) continue;
    link.classList.add('category-shop-link');
    const surface = link.closest('.collection-hub__row, .collection-hub, .shopify-section, section') || document.querySelector('main');
    const price = surface?.querySelector('.collection-hub__product-copy p, product-price .price, .boutique-featured article p, .price');
    if (price) link.style.setProperty('--category-link-price-size', getComputedStyle(price).fontSize);
  }
};
let scheduled = false;
const schedule = () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; syncCategoryLinks(); }); };
addEventListener('resize', schedule);
new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {childList:true,subtree:true});
syncCategoryLinks();
